import { parseUrlSearchParams } from '~/utils/url';

const EMBEDDABLE_USER_LOCAL_STORAGE_KEY = 'shippo_embeddable_user';
const LEGACY_INSTALL_INTENT = 'bm-flow';
const ORDER_DETAILS_INSTALL_INTENT = 'bm-stores-orders';
const ORDERS_LIST_INSTALL_INTENT = 'bm-stores-orders-list';

const AcceptedInstallIntents = [
  LEGACY_INSTALL_INTENT,
  ORDER_DETAILS_INSTALL_INTENT,
  ORDERS_LIST_INSTALL_INTENT,
];

export const checkForEmbeddableUser = (queryString: string): boolean => {
  const queryParams = parseUrlSearchParams(queryString, {
    decode: true,
  });
  if (
    (queryParams.installIntent &&
      AcceptedInstallIntents.includes(queryParams.installIntent as string)) ||
    window.location.search.includes('Embed')
  ) {
    localStorage.setItem(EMBEDDABLE_USER_LOCAL_STORAGE_KEY, 'true');
    return true;
  } else {
    return false;
  }
};

export const getEmbeddableUser = (): boolean => {
  const embeddableUserValue = localStorage.getItem(EMBEDDABLE_USER_LOCAL_STORAGE_KEY);
  if (embeddableUserValue === 'true') return true;
  else return false;
};
